// Ключи кэша ленты. Голова `alerts` в снимок на диск не попадает (`queryPersist.ts`):
// кухонные экраны туда не пускают, а офлайн новых предупреждений нет — их порождает сервер.

export const alertKeys = {
  all: ['alerts'] as const,
  latest: (location: string) => ['alerts', 'latest', location] as const,
  older: (location: string) => ['alerts', 'older', location] as const,
  settings: (location: string) => ['alerts', 'settings', location] as const,
} as const;
